export default __webpack_public_path__ + "static/media/right-arrow.8c9387d3.svg";